module.exports = __webpack_public_path__ + "img/wenh.25e398f9.png";